<template>
  <transition name="fade">
    <BaseModal v-if="modal" @modalState="closeModal($event)">
      <template v-slot:content>
        <div class="c-modal-create-site">
          <div class="c-modal-create-site__content is-centered">
            <div class="c-modal-create-site__header is-size-5">
              <h1 class="c-modal-create-site__title">
                <strong class="has-text-primary"
                  >Crie seu site grátis no Casar.com :)</strong
                >
                <br />
                Que tal deixar seu convite ainda mais elegante com um site
                exclusivo do seu casamento?
              </h1>
            </div>
            <div class="c-modal-create-site__body columns">
              <div class="column">
                <img
                  :src="imgHomeCasar"
                  alt="Home Casar.com"
                  class="is-hidden-mobile"
                />
                <div
                  v-if="imgHomeCasar"
                  class="c-modal-create-site__img-background is-hidden-tablet"
                ></div>
              </div>
              <div class="column has-text-left c-modal-create-site__benefits">
                <ul>
                  <li
                    v-for="item in benefits"
                    :key="item"
                    class="c-modal-create-site__item"
                  >
                    <div class="c-modal-create-site__icon">
                      <base-icon
                        :style="{ marginRight: '10px' }"
                        name="painel/check-list-active"
                        class="has-text-success"
                        width="20"
                        height="21"
                      />
                    </div>

                    {{ item }}
                  </li>
                </ul>
                <p class="c-modal-create-site__more">E muito mais…</p>
              </div>
            </div>
            <div class="c-modal-create-site__footer">
              <div class="c-modal-create-site__actions">
                <a
                  class="c-modal-create-site__action button is-primary"
                  :href="learnMoreUrl"
                  >Saiba mais</a
                >
              </div>
            </div>
          </div>
        </div>
      </template>
    </BaseModal>
  </transition>
</template>

<script>
import BaseModal from '@/components/Wallet/BaseModal.vue'
import imgModal from '@/assets/img/invites/modal/homecasar.jpg'

const SITE_URL = process.env.VUE_APP_SITE_URL

export default {
  components: {
    BaseModal,
  },

  computed: {
    modal: {
      get() {
        return this.$store.state.invites.modalState
      },
      set(payload) {
        this.$store.dispatch('setOpenModal', payload)
      },
    },
  },

  data() {
    return {
      globalTagHTML: null,
      learnMoreUrl: SITE_URL,
      imgHomeCasar: imgModal,
      benefits: [
        'Mais de 30 modelos para você personalizar e construir seu site',
        'Confirmação de presença - RSVP',
        'Lista de presentes em dinheiro com o melhor custo-benefício do mercado',
      ],
    }
  },

  mounted() {
    this.fixGlobalTagHTML()
  },

  methods: {
    updatePage() {
      location.reload()
    },

    closeModal(state) {
      this.modal = state
      this.fixGlobalTagHTML()
    },

    fixGlobalTagHTML() {
      this.globalTagHTML = document.getElementsByTagName('html')[0]

      if (this.modal) {
        this.globalTagHTML.style.position = 'fixed'
        this.globalTagHTML.style.overflow = 'hidden'
      } else {
        this.globalTagHTML.style.position = 'relative'
        this.globalTagHTML.style.overflow = 'initial'
      }
    },
  },
}
</script>

<style lang="scss">
.c-modal-create-site {
  padding: 30px;
  max-width: 360px;
  margin: 0 auto;
  @media (min-width: $tablet) {
    max-width: 700px;
  }

  &__header {
    max-width: 450px;
    margin: 0 auto;
  }

  &__title {
    font-size: 20px;

    strong {
      font-size: 24px;
    }
  }

  &__img-background {
    position: relative;
    min-height: 265px;
    height: auto;
    width: 100%;
    z-index: 1;

    &:before {
      content: '';
      background-image: url('~@/assets/img/invites/modal/homecasar.jpg');
      background-size: 100%;
      position: absolute;
      background-position: center;
      background-repeat: no-repeat;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      margin: auto;
      height: 100%;
      z-index: -1;
    }
  }

  &__body {
    margin-top: 20px;
    margin-bottom: 0 !important;
  }

  &__item {
    display: inline-flex;
    margin: 5px 0;
  }

  &__icon {
    margin-top: 4px;
  }

  &__more {
    color: #3dafb0;
    font-size: 16px;
    font-weight: bold;
    padding: 15px 30px;
  }

  &__footer {
    margin-top: 0;

    .button {
      min-width: 260px;
      min-height: 40px;
    }
  }
}
</style>
